"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.productsOwnedValues = exports.productsOwnedBoolean = exports.payload = exports.initialValuesConfig = exports.initialTouchedConfig = exports.idPrefix = exports.goalsValues = exports.goalsBoolean = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var calcName = exports.calcName = 'financialplanningcheckuptool';
var idPrefix = exports.idPrefix = 'fpct_';

// Page validation goes below!

var validationPage1 = yup.object({
  isPlanningRetirementGoal: yup.boolean(),
  isTransitioningWealthGoal: yup.boolean(),
  isSavingForMajorPurchaseGoal: yup.boolean(),
  isBuildWealthGoal: yup.boolean(),
  isSavingForEducationExpensesGoal: yup.boolean(),
  isFamilyFinanciallySecureGoal: yup.boolean()
}).test('At least one goal is selected', null, value => {
  if (value.isPlanningRetirementGoal || value.isTransitioningWealthGoal || value.isSavingForMajorPurchaseGoal || value.isBuildWealthGoal || value.isBuildWealthGoal || value.isSavingForEducationExpensesGoal || value.isFamilyFinanciallySecureGoal) {
    return true; // Return true if at least one goal is selected
  }
  return new yup.ValidationError('Please check at least one checkbox', null, 'At least one goal is selected');
});

// Page Two of this calculator does not require any validation checking as a user is not required to check any of the checkboxes to advance to the next page
var validationPage2 = yup.object().shape({});

// Page Three does not have any inputs to validate since the recommendations are being calculated there
var validationPage3 = yup.object().shape({});
var validationPage4 = yup.object().shape({
  firstName: yup.string().required('First name is required.').min(2, 'First name must have at least 2 and no more than 40 characters.').matches(/^[a-zA-Z0-9_'.\s-]*$/, 'Allowed special characters are underscore, apostrophe, period, space, and hyphen.'),
  lastName: yup.string().required('Last name is required.').min(2, 'Last name must have at least 2 and no more than 80 characters.').matches(/^[a-zA-Z0-9_'.\s-]*$/, 'Allowed special characters are underscore, apostrophe, period, space, and hyphen.'),
  phone: yup.string().required('10-digit phone number is required.').matches(/^\(\d{3}\) \d{3}-\d{4}$/, '10-digit phone number is required.'),
  email: yup.string().required('Email address is required.').matches(/^[a-zA-Z0-9_.%+-]{1,64}@[a-zA-Z0-9_-]+\.[a-zA-Z]{2,4}$/, 'Email address is not in valid format. Allowed special characters are underscore, period, percentage sign, plus sign and hyphen. Email must have at least 6 and no more than 80 characters.'),
  zip: yup.string().required('ZIP code is required.').matches(/^\d{5}$/, 'Please provide a valid 5-digit ZIP code.')
});
var validationConfig = exports.validationConfig = [validationPage1, validationPage2, validationPage3, validationPage4];

// Initial values go here!
var goalsBoolean = exports.goalsBoolean = {
  isPlanningRetirementGoal: false,
  isTransitioningWealthGoal: false,
  isSavingForMajorPurchaseGoal: false,
  isBuildWealthGoal: false,
  isSavingForEducationExpensesGoal: false,
  isFamilyFinanciallySecureGoal: false
};
var goalsValues = exports.goalsValues = {
  isPlanningRetirementGoal: 'Plan for and live a comfortable retirement',
  isTransitioningWealthGoal: 'Transition wealth',
  isSavingForMajorPurchaseGoal: 'Save for a major purchase',
  isBuildWealthGoal: 'Build wealth/maximize my investments',
  isSavingForEducationExpensesGoal: 'Save for educational expenses',
  isFamilyFinanciallySecureGoal: 'Ensure my family is financially secure'
};
var productsOwnedBoolean = exports.productsOwnedBoolean = {
  hasEstatePlanningServices: false,
  hasTrustServices: false,
  hasTaxPlanning: false,
  hasSavingsAccount: false,
  hasHealthSavingsAccount: false,
  hasEducationSavingsAccount: false,
  hasLifeInsurance: false,
  hasLTCProtection: false,
  hasDisabilityIncomeInsurance: false,
  has401k: false,
  has403b: false,
  has457: false,
  hasIRA: false,
  hasPension: false,
  hasAnnuity: false,
  hasMoneyMarketCD: false,
  hasStocks: false,
  hasBonds: false,
  hasMutualFunds: false,
  hasETFs: false,
  hasOtherInvestments: false
};
var productsOwnedValues = exports.productsOwnedValues = {
  hasEstatePlanningServices: 'Estate planning services',
  hasTrustServices: 'Trust services',
  hasTaxPlanning: 'Tax planning',
  hasSavingsAccount: 'Savings account',
  hasHealthSavingsAccount: 'Health savings account (HSA)',
  hasEducationSavingsAccount: 'Education savings account',
  hasLifeInsurance: 'Life insurance',
  hasLTCProtection: 'Long-term care protection',
  hasDisabilityIncomeInsurance: 'Disability income insurance',
  has401k: '401(k)',
  has403b: '403(b)',
  has457: '457',
  hasIRA: 'Individual retirement account (IRA)',
  hasPension: 'Pension',
  hasAnnuity: 'Annuity',
  hasMoneyMarketCD: 'Money market/CD',
  hasStocks: 'Stocks',
  hasBonds: 'Bonds',
  hasMutualFunds: 'Mutual Funds',
  hasETFs: 'ETFs',
  hasOtherInvestments: 'Other investments (e.g. real estate, cryptocurrency, etc.)'
};
var initialValuesConfig = exports.initialValuesConfig = _objectSpread(_objectSpread(_objectSpread({}, goalsBoolean), productsOwnedBoolean), {}, {
  goalsList: [],
  productsOwnedList: [],
  productsSuggestedList: [],
  goals: '',
  productsOwned: '',
  productsSuggested: '',
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  zip: '',
  trackingInfo: {
    pageUrl: '',
    seoTitle: '',
    utmTerm: '',
    utmMedium: '',
    utmSource: '',
    utmContent: '',
    utmCampaign: '',
    advertisementId: '' // utmObject.Gclid
  }
});
var initialTouchedConfig = exports.initialTouchedConfig = {};
var payload = exports.payload = {};
var propsConfig = exports.propsConfig = {
  config: {
    API_URL: 'https://maurice-api-qa.app.dx.nsawsnprd.massmutual.com/calculator/postStrategicLeads',
    CONTENT_API_CALC_PDF: 'https://maurice-api-qa.app.dx.nsawsnprd.massmutual.com/calculator/html2pdf',
    Icon: 'icon-document-check-black',
    Label: 'Financial plan check-up',
    SecondaryStyle: true,
    HasBorder: true,
    Steps: [{
      Title: '',
      SecondaryDescription: '',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: '',
      SecondaryDescription: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: '',
        Side: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: '',
      Description: '',
      SecondaryDescription: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      RightHandButton: {
        Label: 'View disclosures',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: '',
      Description: '',
      SecondaryDescription: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Submit',
        Icon: '',
        Variant: 'primary',
        Side: '',
        HideNext: false
      },
      RightHandButton: {
        Label: '',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        SecondaryStyle: false,
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }]
  }
};